/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Autocomplete, MenuItem, Select } from "@mui/material";
import style from "./FormModal.module.css";
import AutocompletePlaces from "../../../hooks/autoComplete";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import moment from "moment";

import toast from "react-hot-toast";
const FormModal = ({
  isOpen,
  onClose,
  onSubmit,
  fields,
  resetFormData,
  header,
  initialData,
  isEditing,
}) => {
  const initialFormData = {};
  const initialErrors = {};
  fields.forEach((field) => {
    initialFormData[field.name] = field.isMultiSelect ? [] : "";
    initialErrors[field.name] = "";
  });
  const [formData, setFormData] = useState(initialFormData);
  const [formSubmitted, setFormSubmitted] = useState(true);
  const [errors, setErrors] = useState(initialErrors);
  const [address, setAddress] = React.useState("");
  const [preview, setPreview] = React.useState("");
  // console.log("formData===",formData)
  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setAddress(value);
    setFormData({
      ...formData,
      gAddress: results[0].formatted_address,
      // location.lattitude: latLng.lat,
    });
  };

  useEffect(() => {
    // console.log("initialDa  ta:", initialData);

    if (initialData && Object.keys(initialData).length > 0) {
      // console.log("here")
      setFormData((prevData) => ({
        ...prevData,
        ...initialData,
      }));
      setAddress(initialData.gAddress || "");
    } else {
      // console.log("here2",initialFormData)
      setFormData(initialFormData);
    }
  }, [initialData]);
  // console.log("fields===",fields)

  // console.log("formData",formData)

  const validateFormData = () => {
    // console.log("uuuuuuuu==")
    const newErrors = {};
    fields.forEach((field) => {
      const isEmpty = !formData[field.name];
      const isEditingFileField = field.type === "file" && field.isEditing;
      const isFileEmpty = isEditingFileField && !formData[field.name].name;

      if (field.required && (isEmpty || isFileEmpty)) {
        newErrors[field.name] = `${field.label} is required`;
      } else {
        newErrors[field.name] = "";
      }
      // if (field.name === "fullname") {
      //   const isValidFullName = validateFullName(formData[field.name]);
      //   if (!isValidFullName) {
      //     newErrors[field.name] = "Please enter a valid full name";
      //   }
      // }
      if (field.name === "email") {
        const isValidEmail = validateEmail(formData[field.name]);
        if (!isValidEmail) {
          newErrors[field.name] = "Please enter a valid email address";
        }
      }
      if (field.name === "coins") {
        const coinsValue = Number(formData[field.name]); // Ensure it's a number

        if (isNaN(coinsValue) || coinsValue <= 0) {
          newErrors[field.name] = "Coins must be a number greater than 0";
        }
      }
    });

    setErrors(newErrors);
    // console.log("newErrors===",newErrors)
    return Object.values(newErrors).every((error) => error === "");
  };

  const validateFullName = (name) => {
    const regex = /^[a-zA-Z\s]*$/;
    return regex.test(name);
  };
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  // const validateInput = (input) => {
  //   // Regex to check for alphabets only

  //   console.log("INOUT IN VALIDAT" , input)

  //   const regex = /^[a-zA-Z]+$/;
  //   if (regex.test(input)) {
  //     toast.success("there is no number or spcial GOOD")
  //     return true
  //   } else {
  //     toast.error('Only alphabets are allowed');
  //     return false
  //   }
  // };

  // const validateInput = (input) => {
  //   console.log("input in valudate", input)
  //   for (let i = 0; i < input.length; i++) {
  //     const charCode = input.charCodeAt(i);
  //     if (
  //       !(charCode >= 65 && charCode <= 90) && // A-Z
  //       !(charCode >= 97 && charCode <= 122)   // a-z
  //     ) {
  //       toast.error('Only alphabets are allowed');
  //       return false;
  //     }
  //   }
  //   toast.success("there is no number or spcial GOOD")
  //   return true
  // };

  const validateInput = (input) => {
    const alphabetRegex = /^[A-Za-z]+$/;
    console.log("inpit==", input);
    if (!alphabetRegex.test(input)) {
      toast.error("Only alphabets are allowed");
      return false;
    }

    toast.success("There is no number or special character. Input is valid!");
    return true;
  };

  const handleChange = (fieldName, fieldType) => (event, newValue) => {
    // console.log("Field Name in change", fieldName)
    // console.log("fieldType in change", fieldType)
    // console.log("value in change", event.target.value)

    if (Array.isArray(newValue)) {
      setFormData({ ...formData, [fieldName]: newValue });
    } else if (fieldType === "file") {
      const file = event.target.files[0];
      const url = URL.createObjectURL(file);
      setPreview(url);
      setFormData({ ...formData, [fieldName]: file });
    } else if (fieldType === "datetime-local") {
      // Use moment.utc to format dates consistently
      const formattedDate = moment(event.target.value)
        .utc()
        .add()
        .add(5, "hours")
        .add(30, "minutes")
        .format();
      setFormData({ ...formData, [fieldName]: formattedDate });
    } else if (fieldType === "autoComplete") {
      // console.log("hello");
      // setFormData({ ...formData, [fieldName]: address });
    } else if (fieldName == "fullname") {
      // console.log("newValue", newValue)
      // if (validateInput(event.target.value)) {
      setFormData({ ...formData, [fieldName]: event.target.value });
      // } else { }
    } else {
      setFormData({ ...formData, [fieldName]: event.target.value });
    }
  };
  // console.log("preview===", preview);
  const handleSubmit = () => {
    // console.log("validateFormData()===",validateFormData())
    if (validateFormData()) {
      onSubmit(formData, isEditing, initialData._id);
      setPreview('')
      setFormSubmitted(true);
      onClose();
    } else {
      // console.log("heww");
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    const clearedFormData = {};
    fields.forEach((field) => {
      clearedFormData[field.name] = field.isMultiSelect ? [] : "";
    });
    setFormData(clearedFormData);
    setErrors(initialErrors);
    setFormSubmitted(true);
    onClose();
  };

  useEffect(() => {
    if (resetFormData) {
      console.log("here2");
      setFormData(initialFormData);
      setErrors(initialErrors);
    }
  }, [resetFormData, onClose, onSubmit]);

  const getNestedProperty = (obj, path) => {
    const keys = path.split(".");
    let result = obj;

    for (const key of keys) {
      if (key == "createdAt") {
        result = result[key]?.split("T")[0];
      } else {
        result = result[key];
      }

      if (result === undefined) {
        return "";
      }
    }
    return result;
  };
  // console.log("formSubmit", formSubmitted)
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString();
  };
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      const adjustedData = { ...initialData };
      if (adjustedData.startDate) {
        adjustedData.startDate = moment
          .utc(adjustedData.startDate)
          .add(5, "hours")
          .add(30, "minutes")
          .format("YYYY-MM-DDTHH:mm");
      }
      if (adjustedData.endDate) {
        adjustedData.endDate = moment
          .utc(adjustedData.endDate)
          .add(5, "hours")
          .add(30, "minutes")
          .format("YYYY-MM-DDTHH:mm");
      }
      setFormData((prev) => ({ ...prev, ...adjustedData }));
      setAddress(adjustedData.gAddress || "");
    } else {
      setFormData(initialFormData);
    }
  }, [initialData]);

  return (
    <Modal
      open={isOpen}
      onClose={handleCancel}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        className={style.main_div}
      >
        <Typography
          id="modal-title"
          variant="h5"
          component="h2"
          align="center"
          style={{ textDecoration: "underline" }}
        >
          {header}
        </Typography>
        <form>
          <div style={{ margin: "1rem 0" }}>
            {fields.map((field) => {
              let fieldname = field.name;
              return (
                <div key={field.name} style={{ marginBottom: "10px" }}>
                  <Typography>{field.label}</Typography>
                  {field.type === "select" ? (
                    <Select
                      label={field.label}
                      id={fieldname}
                      name={fieldname}
                      value={formData[fieldname]}
                      onChange={(event) => handleChange(fieldname)(event)}
                      fullWidth
                      error={!!errors[fieldname]}
                      helperText={errors[fieldname]}
                    >
                      {field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : field.isMultiSelect ? (
                    <Autocomplete
                      disabled={field.disabled ? true : false}
                      multiple
                      id={field.name}
                      options={field.options}
                      value={formData[field.name]}
                      onChange={(_, newValue) =>
                        handleChange(field.name)(_, newValue)
                      }
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={!!errors[field.name]}
                          helperText={errors[field.name]}
                        />
                      )}
                    />
                  ) : field.isMultiSelect === false ? (
                    <Select
                      label={field.label}
                      id={field.name}
                      name={field.name}
                      value={formData[field.name]}
                      onChange={(event) => handleChange(field.name)(event)}
                      fullWidth
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      disabled={field.disabled ? true : false}
                    >
                      {field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  ) : field.type === "description" ? (
                    <TextField
                      // label={field.label}
                      multiline
                      rows={4}
                      type={field.type}
                      id={field.name}
                      name={field.name}
                      value={getNestedProperty(formData, fieldname)}
                      onChange={(event) => handleChange(field.name)(event)}
                      fullWidth
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      disabled={field.disabled ? field.disabled : false}
                    />
                  ) : field.type === "file" ? (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(event) =>
                          handleChange(field.name, field.type)(event)
                        }
                      />
                      {/* <h1>{console.log("formData===",formData)}</h1> */}
                      {formData[field.name] && !preview && (
                        <div style={{ marginTop: "10px" }}>
                          <img
                            src={formData[field.name]}
                            // src={preview}
                            alt="preview"
                            style={{
                              maxWidth: "200px",
                              maxHeight: "200px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      )}

                      {preview && (
                        <div style={{ marginTop: "10px" }}>
                          <img
                            // src={formData[field.name] ? formData[field.name]:preview}
                            src={preview}
                            alt="preview"
                            style={{
                              maxWidth: "200px",
                              maxHeight: "200px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      )}
                      {field.required &&
                        !formSubmitted &&
                        !formData[field.name] && (
                          <p
                            className={style.error_msg}
                          >{`${field.label} is required`}</p>
                        )}
                    </>
                  ) : field.type === "datetime-local" ? (
                    <>
                      <TextField
                        // label={field.label}
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        value={moment
                          .utc(getNestedProperty(formData, fieldname))
                          .format("YYYY-MM-DDTHH:mm")}
                        onChange={(event) => handleChange(field.name)(event)}
                        fullWidth
                        error={!!errors[field.name]}
                        helperText={errors[field.name]}
                        disabled={field.disabled ? field.disabled : false}
                        // disabled={true}
                      />
                    </>
                  ) : field.type === "autoComplete" ? (
                    <>
                      <PlacesAutocomplete
                        value={address}
                        onChange={setAddress}
                        onSelect={handleSelect}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            <TextField
                              fullWidth
                              {...getInputProps({
                                placeholder: "Type address",
                              })}
                            />

                            <div>
                              {loading ? <div>...loading</div> : null}

                              {suggestions.map((suggestion) => {
                                const style = {
                                  backgroundColor: suggestion.active
                                    ? "#41b6e6"
                                    : "#fff",
                                };

                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      style,
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>

                      {field.required && !formData[field.name] && (
                        <p
                          className={style.error_msg}
                        >{`${field.label} is required`}</p>
                      )}
                    </>
                  ) : (
                    <>
                      <TextField
                        // label={field.label}
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        value={getNestedProperty(formData, fieldname)}
                        onChange={(event) => handleChange(field.name)(event)}
                        fullWidth
                        error={!!errors[field.name]}
                        helperText={errors[field.name]}
                        disabled={field.disabled ? field.disabled : false}
                      />
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </form>
        <Button onClick={handleCancel} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          sx={{ ml: 4 }}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default FormModal;
